import png from './images/storm.png'

export const colors = {
  dominant: '#732b90',
  highlight: '#fcb53e',
}
export const fullname = 'Storm'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/storm.js